"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckmarkCircle = void 0;
var React = require("react");
var CheckmarkCircle = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b;
    return (React.createElement("svg", { height: "44", width: "44", viewBox: "0 0 44 44", xmlns: "http://www.w3.org/2000/svg", style: style },
        React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "#00CD87", strokeLinecap: "round", strokeWidth: "3", transform: "translate(2 2)" },
            React.createElement("path", { d: "M10.82 21.311l5.246 5.246L29.18 13.443" }),
            React.createElement("circle", { cx: "20", cy: "20", r: "19.672" }))));
};
exports.CheckmarkCircle = CheckmarkCircle;
//# sourceMappingURL=CheckmarkCircle.js.map